import request from '../utils/request.js'


export function getCourseList(){
    return request({
        url:'/getCourseList',
        method:'get'
    })
}


export function getCourseDetail(data){
    return request({
        url:'/getCourseDetail?pid='+data,
        method:'get'
    })
}

export function getCourseProject(data){
    return request({
        url:'/getCourseProject?id='+data,
        method:'get'
    })
}



export function testStudyInfo(data){
    return request({
        url:'/testStudyInfo?id='+data,
        method:'get'
    })
}
export function testStudyInfoByStudentId(data){
    return request({
        url:'/testStudyInfoByStudentId?id='+data,
        method:'get'
    })
}
getTimesDurantion
export function listWorkinfo(data){
    return request({
        url:'/listWorkinfo?id='+data,
        method:'get'
    })
}
export function listWorkinfoByStudentId(data){
    return request({
        url:'/listWorkinfoByStudentId?id='+data,
        method:'get'
    })
}

export function getTimesDurantion(data){
    return request({
        url:'/getTimesDurantion?id='+data,
        method:'get'
    })
}
export function getTimesDurantionByStudentId(data){
    return request({
        url:'/getTimesDurantionByStudentId?id='+data,
        method:'get'
    })
}


export function getUserFile(data){
    return request({
        url:'/getUserFile?id='+data,
        method:'get'
    })
}
/**
 * 用户学习时间保存
 * @param {*} data 
 * @returns 
 */
export function saveStudyTime(data){
    return request({
        url:'/saveStudyTime',
        method:'post',
        data:data
    })
}

/**
 * 在线学习人脸识别
 * @param {*} data 
 * @returns 
 */
export function studyCompareFace(data){
    return request({
        url:'/studyCompareFace',
        method:'post',
        data:data
    })
}